import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../components/FormikControl/FormikControl';
import { Add, Edit } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';
import portalServices from '../portalServices';



function PortalForm({data,refreshList}) {

    const {AppAlert} = useAlert();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [changePassword, setChangePassword] = useState(false);


    const initialValues = {
        "portalId"              : "",
        "displayName"           : "",
        //"url"                   : "",
        "whatsAppNo"            : "",
        "phoneNumberId"         : "",
        "status"                : 0,
    }

    const validationRule = Yup.object({
        portalId:Yup.string().required("Required"),
        displayName:Yup.string().required("Required"),
        //url:Yup.string().required("Required"),
        whatsAppNo:Yup.string().required("Required"),
        phoneNumberId:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const updateData = ()=>{
        setChangePassword(false);
        let autoFill = {
            _id:data._id,
            portalId:data.portalId,
            displayName:data.displayName,
            //url:data.url,
            whatsAppNo:data.whatsAppNo,
            phoneNumberId:data.phoneNumberId,
            status:data.status,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        portalServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            refreshList()
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }



    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik);
                            return (
                                <Form>
                                    <DialogTitle>{"Add New"}</DialogTitle>
                                    <DialogContent>
                                        <div className="row p-2">
                                            <FormikControl control="input" formik={formik} type="text" 
                                                label="Portal Id" name="portalId" 
                                                className="col-md-12 mb-3" 
                                            />
                                            <FormikControl control="input" formik={formik} type="text" 
                                                label="Display Name" name="displayName" 
                                                className="col-md-12 mb-3" 
                                            />
                                            {/*
                                            <FormikControl control="input" formik={formik} type="text" 
                                                label="API Url" name="url" 
                                                className="col-md-12 mb-3" 
                                            />
                                            */}
                                            <FormikControl control="input" formik={formik} type="text" 
                                                label="Whats App No" name="whatsAppNo" 
                                                className="col-md-12 mb-3" 
                                            />
                                            <FormikControl control="input" formik={formik} type="text" 
                                                label="Phone Number Id" name="phoneNumberId" 
                                                className="col-md-12 mb-3" 
                                            />

                                            <FormikControl control="switch" formik={formik} 
                                                label="Satus" name="status" 
                                                className="col-md-12 mb-3" 
                                            />


                                        </div>

                                        <div className="row">
                                        { /* JSON.stringify(formik.values) */ }
                                        </div>
                                        
                                    </DialogContent>
                                    <DialogActions>
                                        
                                        {savingInProgress && <div className="row"><LinearProgress/></div> }
                                        {!savingInProgress && 
                                            <>
                                            <button className="btn btn-success" type="submit">Save</button>
                                            <button className="btn btn-danger" type="button" onClick={handleClose}>Cancel</button>
                                            </>
                                        }
                                        
                                    </DialogActions>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default PortalForm